import store from '@state/store'
import Echo from 'laravel-echo'
import io from 'socket.io-client'

const currentUser = store.state.auth.currentUser || {}
const currentUserId = currentUser.id || undefined
const currentUserToken = store.state.auth.token || undefined

export default function() {
  // check availability
  if (!('Notification' in window)) {
    return
  }

  // check app state
  if (!currentUserId || !currentUserToken) {
    return
  }

  window.io = io

  window.Echo = new Echo({
    broadcaster: 'socket.io',
    host: 'demo.kyndhub.com:6002',
    auth: {
      headers: {
        Authorization: 'Bearer ' + currentUserToken,
      },
    },
  })

  Notification.requestPermission()

  // listening on private channel
  window.Echo.private(`App.User.${currentUserId}`).notification(
    (notification) => {
      if (Notification.permission === 'granted') {
        let title = ''
        const body = notification.message
        if (notification.author !== undefined && notification.author !== false)
          title = notification.author.name
        const browserNotification = new Notification(title, {
          icon: `${window.location.origin}/android-chrome-192x192.png`,
          body: body,
        })
        browserNotification.onclick = function(e) {
          window.location.href = notification.link
        }
      }

      store.dispatch('auth/getNotifications')
    }
  )
}
